import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=2580a43a&scoped=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"
import style0 from "./CreateInvoice.vue?vue&type=style&index=0&id=2580a43a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580a43a",
  null
  
)

export default component.exports